import { WCCContentBlockFactory } from 'components/content/parser.interfaces';
import { IWCCContentBlock, IWCCContentBlockSplitOptions, WCCContentBlockConfig, WCCContentBlockType } from './block.interfaces';

export class WCCContentBlock<T extends WCCContentBlockConfig = WCCContentBlockConfig> implements IWCCContentBlock {
    content: string

    get nodes() {
        return this.getWrappedNodes();
    }

    get type() {
        return this.getType();
    }

    get length() {
        return this.getLength();
    }

    constructor(public config: T) {
        this.content = config.content;
    }

    splitBy(options: IWCCContentBlockSplitOptions, factory: WCCContentBlockFactory): Array<IWCCContentBlock> {
        return [this];
    }

    take(length: number): IWCCContentBlock {
        return this;
    }

    mergeWith(other: IWCCContentBlock): IWCCContentBlock | undefined {
        return undefined;
    }

    equals(other: IWCCContentBlock) {
        return other.constructor === this.constructor &&
            other.content === this.content;
    }

    optimize(prev?: IWCCContentBlock): void {

    }

    clone<T1 = T>(overrides?: Partial<T1>): IWCCContentBlock {
        return new (this.constructor as any)({ ...this.config, ...overrides });
    }

    protected getType(): WCCContentBlockType {
        return 'unknown';
    }

    protected getWrapper(): Node | undefined {
        return undefined;
    }

    protected getNodes(): Array<Node> {
        return [];
    }

    protected getLength() {
        return 0;
    }

    private getWrappedNodes(): Node[] {
        const wrapper = this.getWrapper();
        const nodes = this.getNodes();

        if (wrapper != undefined) {
            nodes.forEach(node => wrapper.appendChild(node));
            return [wrapper];
        } else {
            return nodes;
        }
    }
}